import i18n from 'i18next';
import moment from 'moment';
import 'moment/locale/az';
import 'moment/locale/ka';

// the translations
// (tip move them in a JSON file and import them)
const resources = require('../translations.json');

i18n.init({
    resources,
    lng: 'ru',
    fallbackLng: ['ru', 'en', 'az', 'ka'],
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
        escapeValue: false // react already safes from xss
    }
});

i18n.on('languageChanged', (lng) => {
    moment.locale(lng);
});

export default i18n;



// WEBPACK FOOTER //
// ./src/lib/i18next.ts